module.exports = __webpack_public_path__ + "static/media/paypal.b6291622.svg";